module.exports = __webpack_public_path__ + "static/media/info-button-battles.f942f716.png";